"use client";

import React from "react";
import { ArrowRight, PhoneCall, Sparkles, Activity, Shield, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const conditions = [{
  title: "Musculoskeletal",
  description: "Advanced therapy for joints, tendons, and ligaments to restore function and mobility.",
  icon: Activity
}, {
  title: "Acute & Chronic Pain",
  description: "Targeted acoustic waves to reduce inflammation and eliminate persistent pain at the source.",
  icon: Shield
}, {
  title: "Erectile Dysfunction",
  description: "A safe, drug-free, and non-surgical solution to improve vascular health and performance.",
  icon: Zap
}];
export default function ReadyForAFreshStart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222837" id="immediate-medical-support" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.05] bg-gradient-to-br from-primary/20 via-transparent to-secondary/20">
        <Sparkles className="size-[40rem] text-secondary" strokeWidth={0.5} />
      </div>

      <div className="container mx-auto px-4 relative z-10 sm:px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-5xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center rounded-full border border-border/30 bg-muted/20 px-3 py-1 text-sm font-medium text-muted-foreground mb-8 backdrop-blur-md">
            <Sparkles className="mr-2 size-4 text-secondary animate-pulse" />
            Advanced StemWave Therapy
          </div>

          <h2 className="font-default text-4xl font-bold tracking-tight sm:text-5xl mb-6 text-foreground">
            StemWave Acoustic Wave Therapy
          </h2>
          
          <p className="font-default text-lg leading-relaxed text-muted-foreground mb-12 max-w-3xl mx-auto">
            Experience the future of healing with StemWave. This non-invasive technology uses electro-hydraulic waves to activate your body&apos;s natural repair mechanisms, providing effective relief for Musculoskeletal conditions, Acute/Chronic pain, and Erectile dysfunction.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {conditions.map((item, i) => <div key={i} data-index={i} className="bg-card/40 backdrop-blur-sm border border-border/50 p-8 rounded-lg shadow-lg text-left transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group">
                <div className="mb-4 inline-flex size-10 items-center justify-center rounded-md bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                  <item.icon className="size-5" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-foreground">{item.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>)}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base bg-secondary hover:bg-secondary/90 text-secondary-foreground shadow-lg shadow-secondary/20" asChild>
              <Link to="https://polmedprimarycare.com/contact-us/">
                Book Online
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 text-base border-border/30 hover:bg-muted/30 backdrop-blur-sm" asChild>
              <Link to="tel:727-216-0505">
                <PhoneCall className="mr-2 size-5 text-secondary animate-pulse" />
                727-216-0505
              </Link>
            </Button>
          </div>
          
          <p className="mt-8 text-sm text-muted-foreground/80 font-default">
            Open Mon–Fri 9am–5pm | Saturday 10am–1pm. No appointment necessary for walk-ins.
          </p>
        </div>
      </div>
    </section>;
}